import React from 'react'
import { RiskScoreManagementStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  Paginate,
  Section,
  Table,
  Input,
  Spinner,
  Breadcrumbs,
} from '../../components'
import { ICONS } from '../../themes'
import {
  ROUTE_PATH,
  STRING,
  dateMonDayYearTime,
  toastFail,
  toastActive,
} from '../../helpers'
import { riskScoreManagementController } from '../../apiService'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'
import { pageRiskManagementController, rolesObj } from '../../middleware'
import { find } from 'lodash'
class RiskScoreManagement extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)

    this.state = {
      modals: [{ name: 'editScore', isOpen: false }],
      categorys: [],
      resCategory: {
        limit: null,
        next_page: null,
        offset: null,
        page: null,
        prev_page: null,
        records: [],
        total_page: null,
        total_record: 0,
      },
      formDetail: {
        name: '',
        financial: 25,
        operation: 25,
        regulatory: 25,
        sustainability: 25,
      },
      activePage: 1,
      searchPage: 1,
      isLoading: false,
      isCategoryLoading: false,
      companyID: null,
      checkRole: '',
      checkMultiRole: '',
    }
    this.renderEntriePage = this.renderEntriePage.bind()
    this.renderEditForm = this.renderEditForm.bind()
  }

  componentDidMount() {
    this._isMounted = true
    const { user } = this.props
    this.runGetCategorys(user)
    const roles = pageRiskManagementController().asset()
    const multiRole = pageRiskManagementController().getMultiRole()
    this.setState({ checkRole: roles, checkMultiRole: multiRole })
  }

  componentWillUnmount() {
    this.mounted = false
    this._isMounted = false
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.mounted = true
    if (nextProps && nextProps.user && this.mounted) {
      const { user } = nextProps
      const userID = this.props.user ? this.props.user.id : null
      if (user.id !== userID) {
        this.runGetCategorys(user)
      }
    }
  }

  runGetCategorys = user => {
    if (user) {
      if (this._isMounted) {
        this.setState({ companyID: user.company_id })
      }
      return this.getCategorys(user.company_id)
    }
  }

  getCategorys = async companyID => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      if (companyID) {
        const params = {
          company_id: companyID,
          page: this.state.activePage,
        }
        const res = await riskScoreManagementController().getCategorys(params)
        if (res) {
          this.initState(res)
          if (this._isMounted) {
            this.setState({ isLoading: false })
          }
        }
      }
    } catch (error) {
      throw error
    }
  }

  getCategoryByID = async id => {
    try {
      if (!id) return
      if (this._isMounted) {
        this.setState({ isCategoryLoading: true })
      }
      const res = await riskScoreManagementController().getCategoryByID(id)
      if (res) {
        if (this._isMounted) {
          this.setState({ isCategoryLoading: false })
        }
        this.setDetailCategory(res)
      }
    } catch (error) {
      throw error
    }
  }

  updateCategory = async (
    values = {
      id: null,
      financial: null,
      operation: null,
      regulatory: null,
      sustainability: null,
    },
    formilActions = () => {}
  ) => {
    const { user } = this.props
    try {
      if (
        !values.financial &&
        !values.operation &&
        !values.regulatory &&
        !values.sustainability &&
        !values.id
      )
        return
      else if (this.checkSummaryRiskPercentSuccess(values)) {
        const params = {
          category_risk_id: values.id,
          financial: parseInt(values.financial, 10),
          operation: parseInt(values.operation, 10),
          regulatory: parseInt(values.regulatory, 10),
          sustainability: parseInt(values.sustainability, 10),
        }
        const res = await riskScoreManagementController().updateCategory(params)
        if (res) {
          if (res.status === 'UpdateSuccess') {
            toastActive('Update was successes')
            this.runGetCategorys(user)
          } else {
            toastFail('Update was Fail')
          }
          this.toggleModal('editScore')
          // formilActions.resetForm()
        }
      } else {
        toastFail('Please check input value')
      }
    } catch (error) {
      throw ('update fail', error)
    }
  }

  initState = categorys => {
    if (this._isMounted) {
      return this.setState({
        categorys: categorys.records,
        resCategory: categorys,
      })
    }
  }

  checkSummaryRiskPercentSuccess = (values = {}) => {
    const fullPercent = 100
    if (
      !values.financial &&
      !values.operation &&
      !values.regulatory &&
      !values.sustainability
    ) {
      return
    } else {
      const financial = this.convertStrToInt(values.financial)
      const operation = this.convertStrToInt(values.operation)
      const regulatory = this.convertStrToInt(values.regulatory)
      const sustainability = this.convertStrToInt(values.sustainability)
      const sum = financial + operation + regulatory + sustainability
      if (sum < fullPercent || sum > fullPercent) {
        return false
      } else {
        return true
      }
    }
  }

  convertStrToInt = (str = '') => {
    return parseInt(str)
  }

  setDetailCategory = (
    category = {
      category_name: '',
      financial: null,
      operation: null,
      regulatory: null,
      sustainability: null,
      id: null,
    }
  ) => {
    const {
      category_name,
      financial,
      operation,
      regulatory,
      sustainability,
      id,
    } = category
    if (this._isMounted) {
      return this.setState({
        formDetail: {
          id,
          name: category_name,
          financial,
          operation,
          regulatory,
          sustainability,
        },
      })
    }
  }

  toggleModal = (evt, id, name) => {
    if (this._isMounted) {
      return this.setState(
        prevState => ({
          ...prevState,
          modals: prevState.modals.map(modal => ({
            ...modal,
            isOpen: modal.name === evt ? !modal.isOpen : false,
            Idlist: id,
            Fullname: name,
          })),
        })
        // () => {
        //   console.log(this.state.modals)
        // }
      )
    }
  }

  onClickEdit = async (id, name) => {
    this.toggleModal('editScore')
    document.body.classList.add('modal-open')
    await this.getCategoryByID(id)
  }

  onClickCancel = formikProps => {
    formikProps.resetForm()
    this.toggleModal('editScore')
    document.body.classList.remove('modal-open')
  }

  onPageChange = pageNumber => {
    if (this._isMounted) {
      return this.setState(
        prevState => {
          return { ...prevState, activePage: pageNumber }
        },
        () => {
          const { companyID } = this.state
          this.getCategorys(companyID)
        }
      )
    }
  }

  checkPositiveInt = () => {
    return `^[0-9]+[0-9]*$`
  }

  validateSchema = () => {
    const schema = Yup.object().shape({
      financial: Yup.string()
        .matches(this.checkPositiveInt(), STRING.INTEGER)
        .required(STRING.INVALID),
      operation: Yup.string()
        .matches(this.checkPositiveInt(), STRING.INTEGER)
        .required(STRING.INVALID),
      sustainability: Yup.string()
        .matches(this.checkPositiveInt(), STRING.INTEGER)
        .required(STRING.INVALID),
      regulatory: Yup.string()
        .matches(this.checkPositiveInt(), STRING.INTEGER)
        .required(STRING.INVALID),
    })
    return schema
  }

  renderCategoryList = (categoryList = []) => {
    if (!categoryList && categoryList.length <= 0) return
    return categoryList.map(category => this.renderTbody(category))
  }

  renderTbody = (
    category = { updated_at: '', category_name: '', id: null }
  ) => {
    const { updated_at, category_name, id } = category
    return (
      <Table.TR key={category.id}>
        <Table.TD className="category">{category_name}</Table.TD>

        <Table.TD className="last-update">
          {dateMonDayYearTime(updated_at)}
        </Table.TD>

        <Table.TD className="actions">
          <Section>
            {this.state.checkRole && (
              <Button
                className="link"
                onClick={() => this.onClickEdit(id, name)}
              >
                <Image
                  className="edit-icon"
                  src={ICONS['icon-edit.svg']}
                  alt="edit"
                />
              </Button>
            )}
          </Section>
        </Table.TD>
      </Table.TR>
    )
  }

  renderEntriePage = (categorys, resCategory, activePage) => {
    return (
      <Section className="content-footer">
        <Section className="showing-item">
          Showing{' '}
          {categorys.length === 0
            ? '0'
            : Math.min((resCategory.page - 1) * resCategory.limit + 1)}{' '}
          to{' '}
          {Math.min(
            resCategory.total_record,
            resCategory.limit * resCategory.page
          )}{' '}
          of {resCategory.total_record} entries
        </Section>

        <Section className="paginate-wrapper">
          <Paginate
            activePage={activePage}
            onChange={pageNumber => this.onPageChange(pageNumber)}
            itemsCountPerPage={resCategory.limit}
            totalItemsCount={resCategory.total_record}
            // pageRangeDisplayed={resCategory.total_page}
          />

          <Section className="moveto-wrapper">
            <NumberFormat
              label="Page"
              isHorizontal
              className="paginate-moveto"
              defaultValue="1"
              maxLength="4"
              customInput={Input}
              decimalSeparator={false}
              allowNegative={false}
              allowLeadingZeros={false}
              onChange={e => {
                if (this._isMounted) {
                  return this.setState({ searchPage: parseInt(e.target.value) })
                }
              }}
              isAllowed={values => {
                const { value, floatValue } = values
                if (value == 0 && value !== '') {
                  return false
                }
                if (
                  typeof floatValue === 'undefined' ||
                  typeof value === 'undefined'
                ) {
                  return true
                }
                if (value.charAt(0) === '0') {
                  if (value.charAt(1) && value.charAt(1) != '.') {
                    return false
                  }
                }
                if (this.props.maximum) {
                  return floatValue <= this.props.maximum
                } else {
                  return true
                }
              }}
            />
            <Button
              disabled={
                parseInt(this.state.searchPage) <=
                parseInt(resCategory.total_page)
                  ? false
                  : true
              }
              onClick={() => this.onPageChange(this.state.searchPage)}
            >
              go
            </Button>
          </Section>
        </Section>
      </Section>
    )
  }

  renderEditForm = () => {
    return (
      <Formik
        enableReinitialize
        initialValues={this.state.formDetail}
        validationSchema={this.validateSchema}
        validateOnChange={true}
        validateOnBlur={false}
        onSubmit={(values, formiksAction) => {
          document.body.classList.remove('modal-open')
          this.updateCategory(values, formiksAction)
        }}
      >
        {formikProps => {
          const { values, handleChange, errors, submitForm } = formikProps
          return (
            <Form onSubmit={submitForm}>
              <Modal.Header>Edit</Modal.Header>

              <Modal.Body>
                {this.state.isCategoryLoading ? (
                  <Spinner />
                ) : (
                  <React.Fragment>
                    <Section className="category-score">
                      <span className="header">Category:</span> {values.name}
                    </Section>
                    <Section className="form-wrapper">
                      <Section className="form-group-header">
                        Risk Percent
                      </Section>

                      <Section
                        className={`form-group ${
                          errors.financial && 'is-error'
                        }`}
                      >
                        <label>Financial</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Input
                              type="text"
                              value={values.financial}
                              onChange={handleChange('financial')}
                            />
                            <span className="unit">%</span>
                          </Section>

                          <Section className="message">
                            {errors.financial}
                          </Section>
                        </Section>
                      </Section>

                      <Section
                        className={`form-group ${
                          errors.operation && 'is-error'
                        }`}
                      >
                        <label>Operation</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Input
                              type="text"
                              value={values.operation}
                              onChange={handleChange('operation')}
                            />
                            <span className="unit">%</span>
                          </Section>

                          <Section className="message">
                            {errors.operation}
                          </Section>
                        </Section>
                      </Section>

                      <Section
                        className={`form-group ${
                          errors.regulatory && 'is-error'
                        }`}
                      >
                        <label>Regulatory</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Input
                              type="text"
                              value={values.regulatory}
                              onChange={handleChange('regulatory')}
                            />
                            <span className="unit">%</span>
                          </Section>

                          <Section className="message">
                            {errors.regulatory}
                          </Section>
                        </Section>
                      </Section>

                      <Section
                        className={`form-group ${
                          errors.sustainability && 'is-error'
                        }`}
                      >
                        <label>Sustainability</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Input
                              type="text"
                              value={values.sustainability}
                              onChange={handleChange('sustainability')}
                            />
                            <span className="unit">%</span>
                          </Section>

                          <Section className="message">
                            {errors.sustainability}
                          </Section>
                        </Section>
                      </Section>
                    </Section>
                  </React.Fragment>
                )}
              </Modal.Body>

              <Modal.Footer>
                <Button
                  className="theme-border-gray cancel"
                  onClick={() => this.onClickCancel(formikProps)}
                >
                  Cancel
                </Button>

                <Button
                  className="theme-green save"
                  onClick={formikProps.handleSubmit}
                >
                  Save
                </Button>
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    )
  }

  render() {
    const { modals, categorys, resCategory, activePage } = this.state

    return (
      <React.Fragment>
        <RiskScoreManagementStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  src={ICONS['icon-risk-score-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section className="title">{STRING.RISK_MANAGEMENT}</Section>
                <Breadcrumbs props={this.props} />
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-wrapper">
                <Table className="buyer split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH className="category" id="category_header">
                        CATEGORY
                      </Table.TH>

                      <Table.TH className="last-update" id="last_update_header">
                        LAST UPDATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    {this.state.isLoading ? (
                      <Table.TR>
                        <Table.TD>
                          <Spinner />
                        </Table.TD>
                      </Table.TR>
                    ) : (
                      this.renderCategoryList(categorys)
                    )}
                  </Table.TBODY>

                  {/* {isEmpty(listBuyer) && (
                        <Section className="no-result-found">
                          <Image
                            src={ICONS['icon-ssr.png']}
                            className="no-result"
                          />
                          <p>No result found</p>
                        </Section>
                      )} */}
                </Table>
              </Section>
            </Section>
            {this.renderEntriePage(categorys, resCategory, activePage)}
          </Section>
        </RiskScoreManagementStyled>

        <Modal
          className="buyer edit-score theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'editScore'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          {this.renderEditForm()}
        </Modal>
      </React.Fragment>
    )
  }
}
const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}
export const RiskScoreManagementContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RiskScoreManagement)
